export const pageStyle = { maxWidth: 1460, margin: '0 auto', paddingBottom: 32 };

export const headerStyle = (isMobile) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 12,
  alignItems: isMobile ? 'stretch' : 'center',
  marginBottom: 14,
  flexDirection: isMobile ? 'column' : 'row',
});

export const titleStyle = { margin: 0, fontSize: 22, fontWeight: 900, color: 'var(--text)' };
export const subStyle = { marginTop: 6, fontSize: 13, color: 'var(--text-sub)' };

export const refreshButton = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  height: 36,
  padding: '0 12px',
  border: 'none',
  borderRadius: 7,
  color: '#fff',
  background: '#2563eb',
  fontWeight: 800,
  cursor: 'pointer',
};

export const summaryGridStyle = (isMobile) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr' : '1.4fr 1fr 1fr',
  gap: 10,
  marginBottom: 10,
});

export const summaryStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  padding: 12,
};

export const chipsStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 6,
  marginBottom: 12,
};

export const chipStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  height: 28,
  padding: '0 10px',
  borderRadius: 999,
  background: 'rgba(37,99,235,0.1)',
  color: 'var(--text)',
  fontSize: 12,
  fontWeight: 800,
};

export const messageStyle = {
  marginBottom: 10,
  padding: '9px 12px',
  borderRadius: 8,
  background: 'rgba(37,99,235,0.08)',
  color: 'var(--text)',
  fontSize: 13,
};

export const boardShellStyle = {
  display: 'grid',
  gridTemplateColumns: '54px minmax(0, 1fr) 54px',
  gap: 10,
  alignItems: 'stretch',
};

export const mobileMonthNavStyle = {
  display: 'grid',
  gridTemplateColumns: '42px minmax(0, 1fr) 42px',
  gap: 8,
  alignItems: 'center',
  marginBottom: 10,
};

export const mobileMonthLabelStyle = {
  minWidth: 0,
  height: 40,
  border: '1px solid var(--border)',
  borderRadius: 9,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  fontSize: 15,
  fontWeight: 900,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const mobileMoveButtonStyle = (side, disabled) => ({
  width: 42,
  height: 40,
  border: '1px solid var(--border)',
  borderRadius: 9,
  background: side === 'left' ? 'rgba(37,99,235,0.07)' : 'rgba(13,148,136,0.08)',
  color: 'var(--text)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.55 : 1,
});

export const moveButtonStyle = (side) => ({
  minHeight: 520,
  border: '1px solid var(--border)',
  borderRadius: 10,
  background: side === 'left' ? 'rgba(37,99,235,0.07)' : 'rgba(13,148,136,0.08)',
  color: 'var(--text)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  transition: 'transform 160ms ease, background 160ms ease, opacity 160ms ease',
});
